import { SUPPORTED_CHAIN_IDS } from '@ui/constants/chain';
import { useDataChainId } from '@ui/hooks/datachain';
import { Order } from '@ui/services/contract/hooks/LimitOrderFacet/useGetLimitOrdersBatch/types';
import { ChainId } from '@ui/types/chain';
import { create } from 'zustand';

interface PendingLimitOrdersState {
  pendingLimitOrdersMap: Record<ChainId, Order[]>;
  usePendingLimitOrders: () => Order[];
  addPendingLimitOrder: (pendingLimitOrder: Order, chainId: ChainId) => void;
  removePendingLimitOrder: (orderId: string, chainId: ChainId) => void;
  resetPendingLimitOrders: () => void;
}

const defaultMap = Object.fromEntries(
  SUPPORTED_CHAIN_IDS.map((id) => [id, [] as Order[]]),
) as Record<ChainId, Order[]>;

export const usePendingLimitOrdersStore = create<PendingLimitOrdersState>()(
  (set, get) => ({
    pendingLimitOrdersMap: defaultMap,

    usePendingLimitOrders: () => {
      const chainId = useDataChainId();

      return get().pendingLimitOrdersMap[chainId];
    },

    addPendingLimitOrder: (pendingLimitOrder, chainId) => {
      set((state) => {
        const list = state.pendingLimitOrdersMap[chainId] ?? [];
        const exists = list.some((o) => o.id === pendingLimitOrder.id);
        const updated = exists
          ? list.map((o) =>
              o.id === pendingLimitOrder.id ? pendingLimitOrder : o,
            )
          : [...list, pendingLimitOrder];

        return {
          pendingLimitOrdersMap: {
            ...state.pendingLimitOrdersMap,
            [chainId]: updated,
          },
        };
      });
    },

    removePendingLimitOrder: (orderId, chainId) => {
      set((state) => {
        const list = state.pendingLimitOrdersMap[chainId] ?? [];

        return {
          pendingLimitOrdersMap: {
            ...state.pendingLimitOrdersMap,
            [chainId]: list.filter((o) => o.id !== orderId),
          },
        };
      });
    },
    resetPendingLimitOrders: () =>
      set({
        pendingLimitOrdersMap: defaultMap,
      }),
  }),
);
